<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <!-- <b-card-body> -->
        <data-table
          ref="tableManageCampaign"
          :data-table="dataManageItem"
          :field-table="dataTemplateField"
          :table-for="table"
          :mutationFor="mutationFor"
          :data-for="dataFor"
          :list="list"
          :downloadButton="downloadButton"
          :buttonAddTemplate="buttonAddTemplate"
          @addTemplateID="addNewTemplateID"
        >
        </data-table>
      <!-- </b-card-body> -->
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
import {
  BRow,
  BCol,
  BCard,
  BFormCheckbox,
  BButton,
} from 'bootstrap-vue'
import DataTable from '@/views/component/CheckboxTableTemplate.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormCheckbox,
    BButton,
    DataTable,
  },
  data() {
    return {
      table: 'campaign',
      dataFor: 'dataCampaign',
      mutationFor: 'MANAGETEMPLATE',
      list: 'setTemplateManage',
      action: false,
      downloadButton: false,
      buttonAddTemplate: true,
      checkAll: false,
      selected: false,
    }
  },
  computed: {
    ...mapGetters('campaign', {
      dataTemplateField: 'getManageTemplateField',
      dataManageItem: 'getManageTemplateItem',
      dataCampaignStatus: 'getCampaignManageStatus',
      getListReason: 'getListReason',
    }),
    ...mapGetters('datas', {
      campaignId: 'getSelectedRow',
    }),
  },
  mounted() {
    this.clearTable()
    this.resetRow()
    this.setTemplateManage()
    // console.log(this.dataManageItem);
  },
  methods: {
    ...mapActions('campaign', [
      'setTemplateManage',
      'clearTable',
    ]),
    ...mapMutations('datas', {
      resetRow: 'setSelectedRow',
    }),

    // HANDLE BUTTON ADD TEMPLATE ID
    addNewTemplateID() {
      const routeName = this.$route.matched[0].path
      this.$router.push({ path: `${routeName}/create-template` })
    },
    // END HANDLE BUTTON ADD TEMPLATE ID
  },
}
</script>

<style scoped>
input[type="checkbox"]:disabled + label::before{
  background: rgb(138, 44, 44);
}
input[type="checkbox"]:disabled + label:hover::before{
  background: rgb(122, 59, 59);
  border: 1px solid #d4d4d5;
}
</style>
